import callApi from "./callApi";
import callEport from './export';
import coupon from "./coupon";

const actions = {
    ...coupon,
    ...callApi,
    ...callEport,
    setLoadMore: ({ commit }, payload) => {
        commit("setLoadMore", payload);
    },
    setFilter: ({ commit }, payload) => {
        commit("setFilter", payload);
    },
    setResponse: ({ commit }, payload) => {
        commit("setResponse", payload);
    },

    resetPage: ({ commit }, payload) => {
        commit("resetPage", payload);
    },
    resetList: ({ commit }, payload) => {
        commit("resetList", payload);
    },

    toggleExport: ({commit}, payload) => {
        commit("toggleExport", payload);
    },
    setMinimizedExport: ({commit}, payload) => {
        commit("setMinimizedExport", payload);
    },
    setMultipleExport: ({commit}, payload) => {
        commit("setMultipleExport", payload);
    },
    setDataExport: ({commit}, payload) => {
        commit("setDataExport", payload);
    },
    setCountDataExport: ({commit}, payload) => {
        commit("setCountDataExport", payload);
    },
    setProgressExport: ({commit}, payload) => {
        commit("setProgressExport", payload);
    },

    toggleSelectedTransaksi: ({ commit }, payload) => {
        commit("toggleSelectedTransaksi", payload);
    },
    setGrandTotal: ({ commit }, payload) => {
        commit("setGrandTotal", payload);
    },
    setCheckAll: ({ commit }, payload) => {
        commit("setCheckAll", payload);
    },
    setUnselectedTransaksi: ({ commit }, payload) => {
        commit("setUnselectedTransaksi", payload);
    },
    setSelectedTransaksi: ({ commit }, payload) => {
        commit("setSelectedTransaksi", payload);
    },
    setReminders: ({ commit }, payload) => {
        commit("setReminders", payload);
    },
    removeReminders: ({ commit }, payload) => {
        commit("removeReminders", payload);
    },

    setLastInvoiceView: ({ commit }, payload) => {
        commit("setLastInvoiceView", payload);
    },
    toggleInvoiceShow: ({ commit }, payload) => {
        commit("toggleInvoiceShow", payload);
    },
    setLastTransaksiView: ({ commit }, payload) => {
        commit("setLastTransaksiView", payload);
    },
    toggleTransaksiShow: ({ commit }, payload) => {
        commit("toggleTransaksiShow", payload);
    },
    setLastKonsumenView: ({ commit }, payload) => {
        commit("setLastKonsumenView", payload);
    },
    toggleKonsumenShow: ({ commit }, payload) => {
        commit("toggleKonsumenShow", payload);
    },
};

export default actions;
